import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "../lib/api";
import { useStore } from "../context/Store";

export default function AuthCallback() {
  const done = useRef(false);
  const nav = useNavigate();
  const loc = useLocation();
  const { signIn } = useStore();
  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(loc.hash.slice(1)).get("session_id");
    api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sid } })
      .then(({ data }) => { signIn(data); nav(loc.pathname, { replace: true }); })
      .catch(() => nav("/login", { replace: true }));
  }, []); // eslint-disable-line
  return <div className="min-h-[60vh] grid place-items-center text-stone-500">Signing you in...</div>;
}
